import script from "./filter_block.vue?vue&type=script&setup=true&lang=js"
export * from "./filter_block.vue?vue&type=script&setup=true&lang=js"

import "./filter_block.vue?vue&type=style&index=0&id=4ca734cc&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca734cc"]])

export default __exports__